import React, { useEffect, useMemo, useState } from 'react'
import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
// import ValidationText from './ValidationText';
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList';
import isNull from '../../../../utils/NullChecking';
import { Separator } from '../../utils/utils';

// Viewer Component for Displaying the Checklist
const Dropdown = ({ item, setItem, activeAccordion, validations }) => {
    const { handleSelectDropdown } = useNewItemChange(setItem, 'Viewer', activeAccordion);
    const options = item.options ? item.options.split(Separator) : [];
    const [is, setIs] = useState(true);
    const Search_Name_Data = {
        "DropdownName": "",
    }
    const [searchParamName, setSearchParamName] = useState(Search_Name_Data)
    const Search_Data = {
        "Dropdown": '',
    }
    const [searchParam, setSearchParam] = useState(Search_Data)

    useEffect(() => {
        const existingSelectedOptions = item.selectedOptions?.split(Separator) || [];
        const currentSelected = existingSelectedOptions.map(option => option.split('(D)')[0]);

        if (JSON.stringify(currentSelected) === JSON.stringify(options)) {
            return; // No change
        }

        setItem(prev => {
            return prev.map(section => {
                if (section.key === activeAccordion) {
                    const updatedItems = section.items.map(currItem => {
                        if (currItem.ItemID === item.ItemID) {
                            const list = options.join(Separator);
                            return { ...currItem, selectedOptions: list };
                        }
                        return currItem;
                    });
                    return { ...section, items: updatedItems };
                }
                return section;
            });
        });
    }, []);

    // [
    //     { value: "-1", display: "" },
    //     { value:'FrontBodyDiagram', display:'Front Side'},
    //     { value:'BackBodyDiagram', display:'Back Side'},
    // ]


    // Handle dropdown change
    const handleChangeDD = (e, name) => {
        if (name === 'Dropdown') {
            setIs(false);
            setSearchParamName(prev => ({ ...prev, DropdownName: e.target.value }));
        }
    };
    console.log("validationItemsModal  SingleChoice 2 opt Dropdown  validations?.optionsError",validations)
    // Handle selection from SuperSearch
    const handleSelectedData = (selectedData, name, type) => {
        setIs(true);
        if (!isNull(selectedData)) {
            if (type === "client") {
                if (name === "Dropdown" && !isNull(selectedData)) {
                    setSearchParamName(prev => ({ ...prev, DropdownName: selectedData.display }));
                    setSearchParam({ ...searchParam, Dropdown: selectedData.value });
                    const realOptions = DropdownData.filter(opt => opt.value !== "");
                    const index = realOptions.findIndex(opt => opt.value === selectedData?.value ?? "");
                    console.log("DropdownData:", DropdownData, "Real options:", realOptions, "Index:", index);
                    // Only call handler if a real option is selected
                    if (index !== -1) {
                        handleSelectDropdown(item, index);
                    } else {
                        handleSelectDropdown(item, index, 'unSelect');
                    }
                }
            }
        } else {
            if (name === "Dropdown") {
                setSearchParamName(prev => ({ ...prev, DropdownName: '' }));
                setSearchParam({ ...searchParam, Dropdown: '' });
                handleSelectDropdown(item, -1, 'unSelect');
            }
        }
        return selectedData;
    };

    // Parse options properly: label, checked, TR flag, hintText text
    const selectedOptions = item.selectedOptions?.split(Separator).length > 0
        ? item.selectedOptions.split(Separator).map(optStr => {
            const hasSelected = optStr.includes("(D)");
            const baseLabel = optStr.split("(D)")[0].split("[")[0];

            const metaMatch = optStr.match(/\[(.*?)\]/);
            let textResponse = "false";
            let hintText = "";
            if (metaMatch) {
                const parts = metaMatch[1].split("|");
                parts.forEach(p => {
                    if (p.startsWith("TR=")) textResponse = p.split("=")[1];
                    if (p.startsWith("hintText=")) hintText = p.split("=")[1].replace(/'/g, "");
                });
            }

            return {
                content: baseLabel,
                checked: hasSelected,
                textResponse: textResponse,
                hintText: hintText
            };
        })
        : [];

    const  DropdownData = useMemo(() => {
        let list = (selectedOptions || [])?.map(option => ({
            value: option.content, 
            display: option.content,
        }))
        return list?.length > 0 ? [{ value: "", display: "" }, ...list] : []
    }, [selectedOptions])

    return (
        <div className='content-box d-flex gap-10 align-items-center'>
                <p className={`text text-black w-231px flex-shrink-0 d-flex  justify-content-end gap-01 text-end ${validations?.isInvalid ? 'Denied-clr' : ''}`}>
                    {item.content || '[Insert prompt or question]'}
                    {[true, "true"].includes(item?.isRequired) ? <span className="text font-m Denied-clr fs-14">*</span> : <></>}
                </p>
                <div className={`w-100 input ${validations?.isInvalid ? 'error' : ''}`}>
                    <SuperSearchList
                        type="client"
                        id='Dropdown'
                        name='Dropdown'
                        searchValue={searchParamName.DropdownName}
                        data={DropdownData}
                        onChange={(e) => handleChangeDD(e, 'Dropdown')}
                        getSelectedData={handleSelectedData}
                        is={is}
                        icon={'Simple'}
                        sup_btn='sup_btn'
                        sup_inp='superSearchVisitInp'
                        inputError={validations?.isInvalid}
                    />
                    {validations?.isInvalid ? 
                     <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                        <i className="bi bi-info-circle-fill fs-10"></i>
                        <p className="fs-9 text-white text">Dropdown is Required!</p>
                    </div> : ''}
                </div>
                {/* <div className="d-flex  gap-2">
                    {selectedOptions.length > 0 &&
                        selectedOptions.map((option, index) => (
                            <React.Fragment key={index}>
                                <div className='ar_radio-btn d-flex align-items-center gap-6'>
                                    <div className='custom_check_box d-flex'>
                                        <input
                                            type="radio"
                                            className="form-check-input mt-0"
                                            id={`checklist-${index}-${item.ItemID}`}
                                            checked={option.checked}
                                            onChange={(e) => { e.stopPropagation(); handleSelectDropdown(item, index) }}
                                        // disabled
                                        />
                                        <p className='text ar-orange-text' htmlFor={`checklist-${index}-${item.ItemID}`}>
                                            {option.content || '[Insert Option]'}
                                        </p>
                                    </div>
                                </div>
                            </React.Fragment>
                        ))}
                </div> */}
        </div>
    );
};

export default Dropdown